<template>
    <meta-data
        :title="
            'Kameo Bikes - Vélo occasion ' + bike?.brand + ' ' + bike?.model
        "
        :path="$route.fullPath"
        ogType="website"
        :ogImage="
            $apiUrl() +
            '/storage/assets/images/bikes_pictures/' +
            bike?.id +
            '/A.jpg'
        "
        :isExternalApi="true"
    />
    <InfoBar :text="$translate('components.info-bar.text')" />

    <Header
        logo="/storage/assets/logos/rectangle_blanc.png"
        connectionIsVisible
        contactIsVisible
    />
    <div
        class="content"
        :class="modalIsOpen ? 'dark-white' : 'white'"
        @click="
            if (md.mobile() && modalIsOpen === true) {
                modalIsOpen = false;
            }
        "
    >
        <div
            class="link"
            v-if="md.mobile() ? (modalIsOpen ? false : true) : true"
        >
            <h3 class="h3">
                <RouterLink :to="{ name: 'home' }">
                    {{ $translate('public.shop.home.bikes.home') }}
                </RouterLink>
                <i class="fa-solid fa-chevron-right fa-2xs"></i>
                <RouterLink :to="{ name: 'home-shop' }">
                    {{ $translate('public.shop.home.bikes.shop') }}
                </RouterLink>
                <i class="fa-solid fa-chevron-right fa-2xs"></i>
                <RouterLink :to="{ name: 'bikes-catalog-category' }">
                    {{ $translate('public.shop.home.bikes.catalog') }}
                </RouterLink>
                <i class="fa-solid fa-chevron-right fa-2xs"></i>
            </h3>
            <p class="title">{{ bike?.brand }} {{ bike?.model }}</p>
        </div>
        <div class="header">
            <p>
                {{ $translate('public.shop.home.bikes.card.details.services') }}
            </p>
        </div>
        <div class="body">
            <div class="left pt-12" :class="!md.mobile() ? 'max-w-[50%]' : ''">
                <div
                    class="left-flex"
                    :class="bike.electric !== '1' ? 'mt-4' : ''"
                >
                    <img
                        class="img remove_bg_color"
                        :src="$storageUrl(bike.image)"
                        :alt="bike.brand + ' ' + bike.model"
                        @error="
                            e =>
                                (e.target.src =
                                    '/storage/assets/images/default.png')
                        "
                    />
                    <div class="stats" v-if="bike.electric == '1'">
                        <div>
                            <div class="title">
                                {{
                                    $translate(
                                        'public.shop.home.bikes.card.details.speed',
                                    )
                                }}
                            </div>
                            <div class="stat">
                                {{
                                    bike.utilisation == 'Speed Pedelec'
                                        ? '45 km/h'
                                        : '25 km/h'
                                }}
                            </div>
                        </div>
                        <div class="bar"></div>
                        <div>
                            <div class="title">
                                {{
                                    $translate(
                                        'public.shop.home.bikes.card.details.autonomy',
                                    )
                                }}
                            </div>
                            <div class="stat">{{ bike?.autonomy }} km</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="details">
                <div class="call_to_action">
                    <div class="selling">
                        <div class="heart-container">
                            <h1 class="title text-center">
                                {{ bike.brand + ' ' + bike.model }}
                            </h1>
                            <div
                                class="heart"
                                @click="
                                    addToFav(bike.id);
                                    bike.favorite = !bike.favorite;
                                "
                            >
                                <i
                                    :class="
                                        bike.favorite === true
                                            ? 'fa fa-heart fa-xl'
                                            : 'fa-regular fa-heart fa-xl'
                                    "
                                ></i>
                            </div>
                        </div>
                        <div class="d-flex align-items-end w-100 gap-2 mb-2">
                            <div class="promo-container">
                                <del class="del-price">
                                    {{ formatPrice(bike?.portfolio_value) }}
                                </del>
                                <div class="price">
                                    {{ formatPrice(bike?.price_tvac) }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <hr class="mb-4" />
                            <h2 class="font-bold">
                                {{
                                    $translate(
                                        'public.shop.home.bikes.card.details.description.description-title',
                                    )
                                }}
                            </h2>
                            <p
                                class="text"
                                v-if="bike?.description"
                                v-html="bike?.description"
                            ></p>
                            <p class="text" v-if="!bike?.description">
                                {{
                                    $translate(
                                        'public.shop.home.bikes.card.details.description.description-empty',
                                    )
                                }}
                            </p>
                        </div>

                        <hr class="mb-4" />
                        <div class="sizes">
                            <div class="size-title">
                                {{
                                    $translate(
                                        'public.shop.home.bikes.card.details.size',
                                    )
                                }}
                                : {{ bike.size }}
                            </div>
                        </div>
                        <p class="font-bold">
                            Nombre de kilomètres : {{ bike.kms }} kms
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="leasing-container">
            <div class="leasing">
                <p>
                    {{
                        $translate(
                            'public.shop.home.bikes.card.details.leasing-text',
                        )
                    }}
                </p>

                <div>
                    {{
                        $translate(
                            'public.shop.home.bikes.card.details.leasing.price',
                        )
                    }}:
                    <span
                        class="opacity-50 line-through text-gray-600 m-4"
                        v-if="bike?.leasing_price_tvac_full"
                    >
                        {{
                            formatPrice(bike?.leasing_price_tvac_full) +
                            '/' +
                            $translate(
                                'public.shop.home.bikes.card.details.leasing.month',
                            )
                        }}
                    </span>
                    <strong
                        >{{
                            formatPrice(bike?.leasing_price_tvac) +
                            '/' +
                            $translate(
                                'public.shop.home.bikes.card.details.leasing.month',
                            )
                        }}
                        TVAC</strong
                    >
                </div>
                <primary-button
                    @click="
                        $router.push({
                            name: 'home-pro',
                        })
                    "
                    >{{
                        $translate(
                            'public.shop.home.bikes.card.details.leasing.more-infos',
                        )
                    }}</primary-button
                >
            </div>
        </div>
        <div>
            <h2
                class="text-red font-bold mt-12 ml-4"
                v-if="bike?.accessories?.length"
            >
                Articles inclus avec le vélo
            </h2>
            <div v-if="bike?.accessories?.length" class="w-full">
                <div class="flex w-full gap-4 overflow-auto p-4">
                    <div
                        v-for="accessory in bike?.accessories"
                        :key="accessory"
                        class="border-dashed border-4 rounded-md p-4 min-w-56 text-center relative flex flex-col justify-between"
                    >
                        <img
                            :src="
                                $apiUrl() +
                                '/storage/assets/images/accessories_pictures/' +
                                accessory.accessories_catalog_id +
                                '/A_mini.jpg'
                            "
                            @error="
                                e =>
                                    (e.target.src =
                                        '/storage/assets/images/default.png')
                            "
                            class="remove_bg_color max-h-24 aspect-[1.777]"
                            :alt="
                                'Image accessoire ' +
                                accessory.catalog?.brand +
                                ' ' +
                                accessory.catalog?.model
                            "
                        />
                        <strong>{{ accessory.catalog?.brand }}</strong
                        ><br />
                        {{ accessory.catalog?.model }}<br />
                        <strong
                            >Prix :
                            {{
                                formatPrice(
                                    accessory.catalog?.price_htva * 1.21,
                                )
                            }}</strong
                        ><br />
                        <div>Taille : {{ accessory.size }}</div>
                    </div>
                </div>
            </div>
            <hr class="mt-12" />

            <div class="w-3/4 mx-auto mt-4 pb-4 sm:text-xs md:text-base">
                <h2 class="font-bold text-xl">
                    {{
                        $translate(
                            'public.shop.home.bikes.card.details.techniques.title',
                        )
                    }}
                </h2>

                <div class="">
                    <div
                        v-if="bike?.brand"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.brand',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.brand }}
                        </p>
                    </div>
                    <div
                        v-if="bike?.model"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.model',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.model }}
                        </p>
                    </div>
                    <div
                        v-if="bike?.motor"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.engine',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.motor }}
                        </p>
                    </div>
                    <div
                        v-if="bike?.battery"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.battery',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.battery }}
                        </p>
                    </div>
                    <div
                        v-if="bike?.display_device"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            Console :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.catalog?.display_device }}
                        </p>
                    </div>
                    <div
                        v-if="bike?.transmission"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.transmission',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.transmission }}
                        </p>
                    </div>
                    <div
                        v-if="bike?.catalog?.cassette"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.cassette',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.catalog?.cassette }}
                        </p>
                    </div>
                    <div
                        v-if="bike?.catalog?.brakes"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.brakes',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.brakes }}
                        </p>
                    </div>
                    <div
                        v-if="bike?.catalog?.front_brakes_size"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.front-brake-size',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.catalog?.front_brakes_size }}
                            mm
                        </p>
                    </div>
                    <div
                        v-if="bike?.catalog?.back_brakes_size"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.back-brake-size',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.catalog?.back_brakes_size }}
                            mm
                        </p>
                    </div>
                    <div
                        v-if="bike?.catalog?.weight"
                        class="border-b-2 border-dashed grid grid-cols-2"
                    >
                        <p class="label text-sm font-medium text-gray-700">
                            {{
                                $translate(
                                    'public.shop.home.bikes.card.details.techniques.weight',
                                )
                            }}
                            :
                        </p>
                        <p class="value text-gray-900">
                            {{ bike?.catalog?.weight }} kgs
                        </p>
                    </div>
                </div>
            </div>
            <hr />

            <div
                class="containerDescriptionMotor bg"
                v-if="motor && bike.electric == '1'"
            >
                <img
                    class="item"
                    :src="`/storage/assets/images/motors-description/${
                        motor.image || 'default.png'
                    }`"
                    alt=""
                />
                <div class="bikeDescription">
                    <h3>{{ motor.name }}</h3>
                    <p v-html="motor.description"></p>
                </div>
            </div>

            <div
                class="containerDescriptionBattery"
                v-if="battery && bike.electric == '1'"
            >
                <img
                    class="imgDescription item"
                    :src="`/storage/assets/images/motors-description/${
                        battery.image || 'default.png'
                    }`"
                    alt=""
                />

                <div class="bikeDescription">
                    <h3>{{ battery.name }}</h3>
                    <p v-html="battery.description"></p>
                    <p v-html="battery.link" class="autonomyLink"></p>
                </div>
            </div>

            <div class="more_infos">
                <p>
                    {{
                        $translate(
                            'public.shop.home.bikes.card.details.contact.infos',
                        )
                    }}
                </p>
                <p>
                    {{
                        $translate(
                            'public.shop.home.bikes.card.details.contact.contact-1',
                        )
                    }}
                    <a href="tel:+32 4 290 71 21">+32 4 290 71 21</a>
                    {{
                        $translate(
                            'public.shop.home.bikes.card.details.contact.contact-2',
                        )
                    }}
                    <a href="mailto:info@kameobikes.com">info@kameobikes.com</a>
                </p>
            </div>
        </div>

        <Contact :defaultInfo="userInfos" />
    </div>
    <Footer />
</template>

<script setup>
import { useAuthStore } from '@/js/stores/authStore.js';
import MobileDetect from 'mobile-detect';
import { onBeforeUnmount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import Contact from '@/js/components/Contact.vue';
import Footer from '@/js/components/public/Footer.vue';
import Header from '@/js/components/public/Header.vue';
import InfoBar from '@/js/components/public/InfoBar.vue';
import formatPrice from '@/js/functions/formatPrice.js';
import bikesBatteriesJson from '@/js/json/batteries.json';
import bikesMotorsJson from '@/js/json/motors.json';
import { useApiStore } from '@/js/stores/apiStore';

const md = new MobileDetect(window.navigator.userAgent);
const apiStore = useApiStore();
const authStore = useAuthStore();

const route = useRoute();
const $router = useRouter();

const bike = ref({
    stocks: {},
});

const userInfos = ref({
    firstname: authStore.$state.user?.firstname ?? '',
    lastname: authStore.$state.user?.lastname ?? '',
    companyName: authStore.$state.user?.company?.name ?? '',
    email: authStore.$state.user?.email ?? '',
    phone: authStore.$state.user?.phone ?? '',
    message: '',
});

const modalIsOpen = ref(false);

const motor = ref();
const battery = ref();

const getMotor = motorName => {
    if (!motorName) return '';

    const motor = bikesMotorsJson.find(motor => motor.name === motorName);

    return motor;
};
const getBattery = batteryName => {
    if (!batteryName) return '';

    const battery = bikesBatteriesJson.find(
        battery => battery.name === batteryName,
    );

    return battery;
};

await apiStore
    .apiGet(`/api/used-bikes/${route.params.id}`)
    .then(response => {
        bike.value = response.data;
        motor.value = getMotor(bike.value.motor);
        battery.value = getBattery(bike.value.battery);

        userInfos.value.message =
            "Bonjour,\n \n Je suis intéressé par le test du vélo d'occasion " +
            response.data.brand +
            ' ' +
            response.data.model +
            ' proposé au prix de ' +
            formatPrice(response.data.price_tvac);
    })
    .catch(error => {
        console.error('Error fetching bike data:', error);
    });

watch(
    () => modalIsOpen.value,
    () => {
        if (modalIsOpen.value && md.mobile()) {
            window.scrollTo(0, 0);
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    },
);
onBeforeUnmount(() => {
    document.body.style.overflow = 'auto';
});
</script>

<style lang="scss" scoped>
@use '@/scss/variables' as vars;

.dark-white {
    position: relative;
    width: 100%;
    height: 100%;

    &:before {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        content: '';
        z-index: 100;
    }
}

.white {
    background-color: vars.$whiteColor;
}

.cart-container {
    width: 100%;
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
        margin: 0;
        font-size: vars.$defaultFontSize;
    }

    .success {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem;

        i {
            color: vars.$greenColor;
        }
    }

    .buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
    }
}

.content {
    margin: 0 auto;
    min-height: 100vh;

    .link {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 1rem 0 1rem 1rem;

        .title {
            text-decoration: underline;
            margin: 0;
            display: block;
            margin: 0;
            font-weight: inherit;
            color: vars.$blackColor;
            font-size: vars.$defaultFontSize;

            @media (max-width: 769px) {
                display: none;
            }
        }

        h3 {
            margin: 0;
            font-size: vars.$defaultFontSize;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: vars.$blackColor;
            font-size: vars.$defaultFontSize !important;

            i:last-of-type {
                display: none;
            }

            @media (min-width: 769px) {
                font-size: vars.$tertiaryFontSize;

                i:last-of-type {
                    display: block;
                }
            }

            @media screen and (max-width: vars.$mediumBreakpoint) {
                font-size: 0.8rem !important;
            }
        }

        a {
            color: vars.$blackColor;
        }

        .fa-solid {
            color: vars.$blackColor;
        }
    }

    .header {
        display: flex;
        align-items: center;
        padding: 1rem;
        background-color: vars.$redColor;

        p {
            margin: 0;
            color: vars.$whiteColor;
            font-weight: 550;
            text-align: center;
            width: 100%;
        }
    }

    .body {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .left {
            display: flex;
            flex-direction: column;
            align-items: center;

            .title {
                font-weight: bold;
                font-size: vars.$tertiaryFontSize;
                color: vars.$redColor;
                padding: 1rem 0 0 0;
            }

            .left-flex {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 1rem;
            }

            p {
                font-size: vars.$defaultFontSize;
                margin: 0;
                padding: 0.5rem 1rem;
                text-align: center;
            }

            img {
                width: 100%;
            }

            .stats {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 1rem;
                text-transform: uppercase;

                .bar {
                    width: 3px;

                    opacity: 0.5;
                    height: 4rem;
                    background-color: vars.$redColor;
                }
            }
        }

        .details {
            padding: 1rem;

            .call_to_action {
                .selling {
                    .description {
                        h2 {
                            font-size: vars.$tertiaryFontSize;
                        }

                        .text {
                            font-size: vars.$defaultFontSize;
                            margin: 0;
                            padding: 0.5rem 0;
                        }
                    }

                    .used-bike {
                        .price {
                            font-size: vars.$tertiaryFontSize;
                            font-weight: bold;
                            color: vars.$blackColor;
                            margin: 0 !important;
                        }
                    }

                    .promo-container {
                        .del-price {
                            text-decoration: line-through;
                        }

                        .price {
                            font-size: vars.$tertiaryFontSize;
                            font-weight: bold;
                            color: vars.$blackColor;
                            margin: 0 !important;
                        }
                    }

                    .heart-container {
                        margin-top: 2rem;
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .title {
                            font-weight: bold;
                            font-size: vars.$tertiaryFontSize;
                            color: vars.$redColor;
                            text-transform: uppercase;
                            margin: 0 0 1rem 0;
                        }

                        i {
                            color: vars.$redColor;
                        }
                    }

                    .price {
                        font-size: vars.$tertiaryFontSize;
                        font-weight: bold;
                        text-align: start;
                        margin: 0 0.5rem;
                        color: vars.$blackColor;

                        span {
                            font-size: vars.$defaultFontSize;
                            font-weight: normal;
                            text-decoration: underline;
                            color: vars.$greyColor;
                        }
                    }

                    .heart {
                        cursor: pointer;

                        @media screen and (max-width: vars.$mediumBreakpoint) {
                            margin-bottom: 0.6rem;
                        }

                        i {
                            color: vars.$redColor;
                        }
                    }

                    .stats {
                        display: flex;
                        flex-direction: column;
                        border: 1.5px solid vars.$redColor;
                        border-radius: vars.$borderRadius;
                        width: 100%;
                        margin: 1rem 0;
                        padding: 1rem;
                        gap: 0.2rem;
                        text-transform: uppercase;

                        div {
                            display: flex;
                            justify-content: space-between;
                            color: vars.$redColor;
                            font-weight: bold;

                            span {
                                color: vars.$blackColor;
                            }
                        }
                    }

                    .sizes-container {
                        border: 1.5px solid vars.$redColor;
                        border-radius: vars.$borderRadius;
                        width: 100%;
                        padding: 0.5rem 1rem;

                        .top {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-size: vars.$defaultFontSize;
                            font-weight: bold;

                            i {
                                color: vars.$redColor;
                            }
                        }

                        .sizes {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                            gap: 0.8rem;
                            margin: 1rem 0 1rem 0;

                            .size {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                padding: 1rem 1rem;
                                border-radius: vars.$borderRadius;
                                width: fit-content;
                                cursor: pointer;
                                transition: vars.$defaultTransition;
                                margin: 0;

                                &:hover {
                                    background-color: vars.$redColor;
                                    color: vars.$whiteColor;
                                }

                                .active {
                                    background-color: vars.$redColor;
                                    color: vars.$whiteColor;
                                }
                            }
                        }
                    }

                    .buttons {
                        p {
                            text-align: left;
                        }

                        margin-top: 1rem;
                        width: 100%;
                        gap: 1rem;

                        div {
                            display: flex;
                            justify-content: center;
                        }

                        div {
                            display: flex;
                            flex-direction: column;
                            gap: 1rem;
                        }

                        @media screen and (min-width: vars.$mediumBreakpoint) {
                            div {
                                flex-direction: row;
                                gap: 1rem;
                            }
                        }
                    }

                    .drawer {
                        display: flex;
                        margin-top: 2rem;
                        width: 100%;
                        flex-direction: column;
                        gap: 0.8rem;

                        @media screen and (min-width: vars.$mediumBreakpoint) {
                            display: none;
                        }

                        .description {
                            .top {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;

                                .title {
                                    margin: 0;
                                    color: vars.$blackColor;
                                    font-weight: bold;
                                }

                                i {
                                    color: vars.$redColor;
                                }
                            }
                        }

                        .specs {
                            .top {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;

                                .title {
                                    margin: 0;
                                    color: vars.$blackColor;

                                    font-weight: bold;
                                }

                                i {
                                    color: vars.$redColor;
                                }
                            }

                            .spec {
                                display: flex;

                                .label {
                                    font-size: vars.$defaultFontSize;
                                    font-weight: bold;
                                    margin: 0;
                                }

                                .value {
                                    font-size: vars.$defaultFontSize;
                                    margin: 0;
                                    margin-left: 1rem;
                                }
                            }
                        }
                    }

                    .size {
                        width: 100%;
                        height: 3rem;
                        margin: 1rem 0;
                        padding: 0 1rem;
                        font-size: vars.$defaultFontSize;
                        cursor: pointer;

                        .active {
                            background-color: vars.$redColor;
                            color: vars.$whiteColor;
                        }

                        border: 1px solid vars.$redColor;

                        &:focus {
                            outline: none;
                        }
                    }

                    .size_guide {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 0.5rem;
                        margin: 0.35rem 0.5rem;

                        a {
                            font-size: vars.$defaultFontSize;
                            font-weight: 100;
                            color: vars.$greyColor;
                            text-decoration: none;
                            transition: vars.$defaultTransition;

                            &:hover {
                                color: vars.$redColor;
                            }
                        }

                        i {
                            color: vars.$greyColor;

                            margin-right: 0.5rem;
                        }
                    }

                    Button {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;

                        &:hover {
                            transform: translateY(-2px);
                        }

                        .text {
                            margin: 0.2rem 0 0 1rem;
                        }
                    }
                }
            }

            .info {
                display: flex;
                align-items: center;
                margin: 0 -1rem -1rem -1rem;
                padding: 1rem 0;
                background-color: vars.$greyColor;

                img {
                    width: 50px;
                }

                p {
                    font-size: vars.$defaultFontSize;
                    font-weight: 100;
                    margin: 0;
                }
            }
        }

        .border-red {
            border: 1px solid vars.$redColor !important;
        }

        .border-black {
            color: vars.$greyColor;
            pointer-events: none;
            border: 1px solid vars.$greyColor !important;
        }

        .active-size {
            background-color: vars.$redColor;
            color: vars.$whiteColor;
        }

        @media screen and (min-width: vars.$mediumBreakpoint) {
            flex-direction: row;

            .link {
                padding: 1rem 2rem 0;
                margin-bottom: 2rem;

                h3 {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    color: vars.$blackColor;
                    font-size: 1.2rem;
                }

                a {
                    color: vars.$blackColor;
                    text-decoration: underline;
                }

                .fa-solid {
                    color: vars.$blackColor;
                }
            }

            .body {
                width: 100%;

                .details {
                    padding: 2rem 2rem 0 2rem;

                    .call_to_action {
                        .selling {
                            margin: 0;

                            .size {
                                width: 100%;
                            }
                        }
                    }

                    .info {
                        margin: 0 -2rem 0 -2rem;
                    }
                }
            }
        }
    }

    .containerDescriptionMotor,
    .containerDescriptionBattery {
        padding: 2rem;
        width: 100%;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        justify-content: space-around;

        .item {
            margin-bottom: 1rem;
            mix-blend-mode: multiply;
            max-width: 400px;
        }

        h3 {
            margin-bottom: 2rem;
            font-size: vars.$tertiaryFontSize;
            color: vars.$redColor;
            font-weight: bold;
        }

        p {
            text-align: justify;
            font-size: vars.$defaultFontSize;
        }
    }

    @media screen and (min-width: vars.$mediumBreakpoint) {
        .containerDescriptionMotor,
        .containerDescriptionScreen {
            display: flex;
            margin-top: 2rem;
            justify-content: center;
            margin-bottom: 0;
            justify-content: space-around;
        }

        .containerDescriptionMotor,
        .containerDescriptionBattery {
            display: flex;
            flex-direction: row;
            align-items: center;

            .bikeDescription {
                padding: 2.5rem;
            }

            img {
                width: 50%;
                height: auto;
                mix-blend-mode: multiply;
            }

            h3 {
                margin-bottom: 2rem;
                font-size: vars.$tertiaryFontSize;
                color: vars.$redColor;
                font-weight: bold;
            }

            p {
                font-size: 1.2rem;
                text-align: justify;
                width: 40rem;
                font-size: vars.$defaultFontSize;
            }
        }

        .containerDescriptionBattery {
            flex-direction: row-reverse;
            margin-bottom: 2rem;
        }
    }

    .autonomyLink {
        font-weight: bold;
    }

    .more_infos {
        padding: 1rem;

        a {
            color: vars.$redColor;
            text-decoration: none;
            font-weight: bold;
            font-size: vars.$defaultFontSize;
            transition: vars.$defaultTransition;

            &:hover {
                color: vars.$redColor;
                text-decoration: underline;
            }
        }

        .title {
            color: vars.$redColor;
            margin-top: 1rem;
        }

        .detail {
            display: flex;

            .label {
                font-size: vars.$defaultFontSize;
                font-weight: bold;
                margin: 0;
            }

            .value {
                font-size: vars.$defaultFontSize;
                margin: 0;
                margin-left: 1rem;
            }
        }
    }

    .more_infos {
        text-align: center;
    }
}

.leasing-container {
    margin-top: 2rem;

    .leasing {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        border: 1px solid vars.$redColor;
        padding: 1rem;
        border-radius: 0.8rem;
        margin: 0 2rem;

        div {
            font-weight: bold;
            color: vars.$redColor;

            strong {
                color: vars.$blackColor;
            }
        }

        p {
            margin: 0;
        }
    }
}

@media screen and (min-width: vars.$mediumBreakpoint) {
    .specs-container {
        .specs {
            display: flex;
            justify-content: center;

            .left {
                font-weight: bold;
            }

            .left {
                width: 15%;

                span {
                    margin-left: 3rem;
                }
            }

            .right {
                width: 75%;

                text-align: start;
            }
        }

        hr {
            border: 0;
            height: 1px;
            background: vars.$blackColor;
            opacity: 1 !important;
        }

        .title {
            margin: 2rem 0 1rem 3rem;
            font-size: vars.$tertiaryFontSize;
            font-weight: bold;
        }
    }

    .leasing-container {
        margin-top: 2rem;

        .leasing {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            border: 1px solid vars.$redColor;
            padding: 1rem;
            border-radius: 0.8rem;
            margin: 0 2rem;

            div {
                font-weight: bold;
                color: vars.$redColor;

                strong {
                    color: vars.$blackColor;
                }
            }

            p {
                margin: 0;
            }
        }
    }

    .details {
        width: 40%;

        @media screen and (max-width: vars.$mediumBreakpoint) {
            width: 100%;
        }
    }

    .sizes {
        display: flex;
        flex-direction: column;

        width: 100%;

        .size-title {
            margin-bottom: 1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            div {
                font-weight: normal;
            }

            font-weight: bold;
        }

        .size_guide {
            display: flex;
            justify-content: unset !important;
        }

        .size-container {
            display: flex;
            justify-content: center;
            gap: 0.5rem;
            width: fit-content;

            .size {
                border-radius: 0.5rem;
                margin: 0 !important;
                padding: 0.5rem 1rem !important;
                width: fit-content !important;
                height: fit-content !important;
                transition: vars.$defaultTransition;

                &:hover {
                    background-color: vars.$redColor;
                    color: vars.$whiteColor;
                }
            }
        }

        .ean_code {
            margin-top: 0.5rem;
        }
    }
}

.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    .vue-modal-inner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: vars.$whiteColor;
        border-radius: vars.$borderRadius;
        padding: 3rem;
        width: 80%;
        max-width: 70rem;
        max-height: 75%;
        box-shadow: vars.$allShadows;
        overflow: auto;
        word-break: break-word;

        .vue-modal-header {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 4rem;

            .vue-modal-title {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 1rem;

                h1 {
                    font-size: vars.$primaryFontSize;
                    text-transform: uppercase;
                    font-weight: bold;
                    margin: 0;
                }

                i {
                    position: inherit;
                    color: vars.$greenColor;
                }
            }

            i {
                position: fixed;
                top: 1rem;
                right: 1rem;
                cursor: pointer;
            }

            .align-right {
                margin-left: auto;
            }
        }
    }

    .body {
        p {
            margin: 0;
        }

        .cart-item {
            display: flex;
            align-items: center;
            justify-content: space-around;

            img {
                width: auto;
                height: 100px;
                object-fit: contain;
            }
        }

        hr {
            border: 0;
            height: 1px;
            background: vars.$blackColor;
            opacity: 1 !important;
        }
    }

    .buttons {
        display: flex;
        justify-content: center;
        gap: 1rem;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}

.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
}
</style>
